import styles from './summary-item.module.css'
import { Text, SvgIcon } from '@cinch-labs/design-system'

export interface SummaryItemProps {
  title: string
  children: React.ReactNode
  onEdit: () => void
}

export const SummaryItem = ({ title, children, onEdit }: SummaryItemProps) => (
  <div className={styles.summaryItemContainer}>
    <div className={styles.contentContainer}>
      <Text fontSizeFixed="m" className={styles.title}>
        {title}
      </Text>
      {children}
    </div>
    <button
      type="button"
      className={styles.editButton}
      onClick={onEdit}
      aria-label="Edit"
    >
      <SvgIcon name="edit-v2" color="toreaBay" />
    </button>
  </div>
)
